const TOKEN_KEY = 'immediateLoadingAdminToken'
const EXPIRES_AT_KEY = 'immediateLoadingAdminExpiresAt'
const ADMIN_KEY = 'immediateLoadingAdmin'
const SYNC_EVENT_NAME = 'immediate-loading-admin-session-synced'

function clearStoredAuth () {
  ;[localStorage, sessionStorage].forEach(storage => {
    storage.removeItem(TOKEN_KEY)
    storage.removeItem(EXPIRES_AT_KEY)
    storage.removeItem(ADMIN_KEY)
  })
}

function storedAuth () {
  const token = localStorage.getItem(TOKEN_KEY) || ''
  const expiresAtEpochMs = Number(localStorage.getItem(EXPIRES_AT_KEY) || 0)
  if (!token || !expiresAtEpochMs || expiresAtEpochMs <= Date.now() + 5000) return null
  try {
    const admin = JSON.parse(localStorage.getItem(ADMIN_KEY) || 'null')
    const user = JSON.parse(localStorage.getItem('sysUserInfo') || 'null')
    if (!admin || !user || !admin.id || !admin.account || String(admin.id) !== String(user.id || '') || String(admin.account) !== String(user.account || '')) return null
    return { token, expiresAtEpochMs, admin }
  } catch (error) { return null }
}

function notifySync () {
  if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent(SYNC_EVENT_NAME))
}

// 与主后台一样使用本机浏览器会话；其他标签页通过浏览器存储变化感知登录状态。
if (typeof window !== 'undefined') {
  window.addEventListener('storage', event => {
    if (event.key === TOKEN_KEY) notifySync()
  })
}

export function saveImmediateLoadingAdminSession (auth) {
  if (!auth || !auth.token || !auth.expiresAtEpochMs || !auth.admin) throw new Error('管理员登录响应不完整')
  clearStoredAuth()
  localStorage.setItem(ADMIN_KEY, JSON.stringify(auth.admin))
  localStorage.setItem(EXPIRES_AT_KEY, String(auth.expiresAtEpochMs))
  localStorage.setItem(TOKEN_KEY, auth.token)
  notifySync()
}

export function clearImmediateLoadingAdminSession () { clearStoredAuth() }
export function getImmediateLoadingAdminToken () { const auth = storedAuth(); return auth ? auth.token : '' }
export function getImmediateLoadingAdmin () { const auth = storedAuth(); return auth ? auth.admin : null }
export function hasValidImmediateLoadingAdminSession () { return Boolean(storedAuth()) }
export function requestImmediateLoadingAdminSession () { return Promise.resolve(hasValidImmediateLoadingAdminSession()) }
export const IMMEDIATE_LOADING_ADMIN_SYNC_EVENT = SYNC_EVENT_NAME



// WEBPACK FOOTER //
// ./src/assets/utils/immediateLoadingAdminSession.js